import React from 'react'

import ExternalLink from '@/components/misc/ExternalLink'
import { arrayToCommaSeparatedString } from '@/lib/helpers/helperFunctions'
import { ROUTES } from '@/lib/routes'

interface Props {
  recipientsWithSameEmailDomain: string[]
}

const InvitingColleagueWarningMessage: React.FC<Props> = ({
  recipientsWithSameEmailDomain,
}) => (
  <div>
    It looks like you're inviting a colleague (
    {arrayToCommaSeparatedString(recipientsWithSameEmailDomain)}). Are you sure
    you want to invite them as a referral partner? Referral invites are for
    advisers you share clients with. To invite colleagues, use the{' '}
    <ExternalLink
      href={ROUTES.manageUsers({ searchParams: { showInviteModal: 'true' } })}
    >
      Manage Users
    </ExternalLink>{' '}
    page.
  </div>
)

export default InvitingColleagueWarningMessage
